(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["permania-lash-benefits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('.pm-lash-benefits[data-motion="true"]:not([data-motion-ready])').forEach((section) => {
        section.dataset.motionReady = 'true';
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          section.classList.add('is-visible');
          return;
        }
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              section.classList.add('is-visible');
              observer.disconnect();
            }
          });
        }, { threshold: 0.12 });
        observer.observe(section);
      });
    };
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["permania-lash-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('permania-lash-gallery')) {
    customElements.define('permania-lash-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this._controller) return;
        this._controller = new AbortController();
        const signal = this._controller.signal;
        const track = this.querySelector('[data-gallery-track]');
        if (!track) return;
        const cards = [...track.querySelectorAll('.pm-lash-gallery__card:not(.pm-lash-gallery__card--clone)')];
        const tail = track.querySelector('.pm-lash-gallery__tail');
        const clones = [];
        if (cards.length > 1) {
          for (const card of cards) {
            const clone = card.cloneNode(true);
            clone.classList.add('pm-lash-gallery__card--clone');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('inert', '');
            clone.removeAttribute('data-shopify-editor-block');
            clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
            track.insertBefore(clone, tail);
            clones.push(clone);
          }
        }
        const previous = this.querySelector('[data-gallery-prev]');
        const next = this.querySelector('[data-gallery-next]');
        const count = this.querySelector('[data-gallery-count]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let index = 0;
        let visible = false;
        let paused = false;
        let timer;
        let frame = 0;
        let tickerFrame = 0;
        let scrollIdle;
        let normalizing = false;
        let motionBehavior;
        const interval = () => {
          const value = Number(this.dataset.interval);
          return Number.isFinite(value) && value >= 0 ? value : 5000;
        };
        const position = card => card.offsetLeft - cards[0].offsetLeft;
        const cycleWidth = () => clones.length ? position(clones[0]) : 0;
        const update = () => {
          if (!cards.length) return;
          const cycle = cycleWidth();
          const left = cycle && track.scrollLeft >= cycle ? track.scrollLeft - cycle : track.scrollLeft;
          index = cards.reduce((best, card, i) => Math.abs(position(card) - left) < Math.abs(position(cards[best]) - left) ? i : best, 0);
          if (count) count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
          if (previous) previous.disabled = cards.length < 2 || index === 0;
          if (next) next.disabled = cards.length < 2;
        };
        const normalize = onDone => {
          if (normalizing) return true;
          const cycle = cycleWidth();
          if (!cycle || track.scrollLeft < cycle - 2) return false;
          normalizing = true;
          const oldSnap = track.style.scrollSnapType;
          const oldBehavior = track.style.scrollBehavior;
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = Math.max(0, track.scrollLeft - cycle);
          requestAnimationFrame(() => {
            track.style.scrollSnapType = oldSnap;
            track.style.scrollBehavior = oldBehavior;
            normalizing = false;
            update();
            onDone?.();
          });
          return true;
        };
        const cancelMotion = () => {
          if (frame) cancelAnimationFrame(frame);
          frame = 0;
          track.style.scrollSnapType = '';
          if (motionBehavior !== undefined) {
            track.style.scrollBehavior = motionBehavior;
            motionBehavior = undefined;
          }
        };
        const go = target => {
          if (cards.length < 2) return;
          stop();
          cancelMotion();
          const cardIndex = Math.max(0, Math.min(target, cards.length - 1));
          let destination = target >= cards.length ? position(clones[0]) : position(cards[cardIndex]);
          if (interval() === 0 && target > index && destination < track.scrollLeft && clones[cardIndex]) {
            destination = position(clones[cardIndex]);
          }
          if (reducedMotion.matches) {
            const oldBehavior = track.style.scrollBehavior;
            track.style.scrollBehavior = 'auto';
            track.scrollLeft = destination;
            track.style.scrollBehavior = oldBehavior;
            if (!normalize(start)) start();
            update();
            return;
          }
          const from = track.scrollLeft;
          const distance = destination - from;
          if (Math.abs(distance) < 1) { start(); return; }
          const duration = Math.max(500, Math.min(1200, Number(this.dataset.duration) || 900));
          let started;
          track.style.scrollSnapType = 'none';
          motionBehavior = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          const step = now => {
            if (started === undefined) started = now;
            const progress = Math.min(1, (now - started) / duration);
            const eased = interval() === 0 ? progress : progress < .5 ? 4 * progress ** 3 : 1 - Math.pow(-2 * progress + 2, 3) / 2;
            track.scrollLeft = from + distance * eased;
            update();
            if (progress < 1) {
              frame = requestAnimationFrame(step);
            } else {
              frame = 0;
              track.style.scrollSnapType = '';
              track.style.scrollBehavior = motionBehavior;
              motionBehavior = undefined;
              if (!normalize(start)) start();
              update();
            }
          };
          frame = requestAnimationFrame(step);
        };
        const stop = () => {
          if (timer !== undefined) clearTimeout(timer);
          timer = undefined;
          if (tickerFrame) cancelAnimationFrame(tickerFrame);
          tickerFrame = 0;
        };
        const start = () => {
          stop();
          if (!this.isConnected || this.dataset.autoplay !== 'true' || reducedMotion.matches || !visible || paused || frame || normalizing || cards.length < 2) return;
          if (interval() === 0) {
            const speed = Math.max(20, Math.min(120, Number(this.dataset.speed) || 60));
            let previousTime;
            const tick = now => {
              if (previousTime !== undefined) {
                const cycle = cycleWidth();
                if (cycle > 0) {
                  track.scrollLeft += Math.min(now - previousTime, 64) * speed / 1000;
                  if (track.scrollLeft >= cycle) track.scrollLeft -= cycle;
                  update();
                }
              }
              previousTime = now;
              tickerFrame = requestAnimationFrame(tick);
            };
            tickerFrame = requestAnimationFrame(tick);
            return;
          }
          timer = setTimeout(() => { timer = undefined; go(index + 1); }, interval());
        };
        previous?.addEventListener('click', () => go(index - 1), { signal });
        next?.addEventListener('click', () => go(index + 1), { signal });
        track.addEventListener('scroll', () => {
          if (frame || tickerFrame) return;
          requestAnimationFrame(update);
          clearTimeout(scrollIdle);
          scrollIdle = setTimeout(() => { if (frame || tickerFrame) return; if (!normalize(start)) start(); update(); }, 150);
        }, { passive: true, signal });
        track.addEventListener('scrollend', () => {
          if (!frame && !tickerFrame) { clearTimeout(scrollIdle); if (!normalize(start)) start(); update(); }
        }, { signal });
        track.addEventListener('pointerdown', () => { stop(); cancelMotion(); }, { signal });
        track.addEventListener('pointerup', () => {
          if (!frame && !tickerFrame) {
            clearTimeout(scrollIdle);
            scrollIdle = setTimeout(() => { if (!normalize(start)) start(); }, 180);
          }
        }, { signal });
        track.addEventListener('wheel', () => {
          stop();
          cancelMotion();
          clearTimeout(scrollIdle);
          scrollIdle = setTimeout(() => { if (!normalize(start)) start(); }, 180);
        }, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            go(index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && interval() > 0) { paused = true; stop(); } }, { signal });
        this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && paused) { paused = false; start(); } }, { signal });
        this.addEventListener('focusin', () => { paused = true; stop(); }, { signal });
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { paused = false; start(); } }, { signal });
        window.addEventListener('resize', () => { if (!cards.length) return; cancelMotion(); track.scrollLeft = position(cards[index]); update(); start(); }, { signal });
        reducedMotion.addEventListener?.('change', start, { signal });
        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver(entries => { visible = entries[0]?.isIntersecting ?? false; start(); }, { threshold: .2 });
          this._observer.observe(this);
        } else { visible = true; start(); }
        this._cleanup = () => { stop(); cancelMotion(); clearTimeout(scrollIdle); clones.forEach(clone => clone.remove()); };
        update();
      }
      disconnectedCallback() {
        this._controller?.abort();
        this._controller = null;
        this._observer?.disconnect();
        this._cleanup?.();
        this._cleanup = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["permania-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-product-reviews]:not([data-reviews-ready])').forEach((section) => {
        section.dataset.reviewsReady = 'true';
        const rail = section.querySelector('[data-review-rail]');
        const previous = section.querySelector('[data-review-prev]');
        const next = section.querySelector('[data-review-next]');
        if (!rail || !previous || !next) return;
        const update = () => {
          previous.disabled = rail.scrollLeft <= 2;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        };
        const move = (direction) => {
          const card = rail.querySelector('.pm-product-reviews__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(rail).gap) || 0;
          rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        rail.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });
    };
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
